/** @format */

import React from 'react';
import { useSiteData, DataContextProps } from '@context';
import {
  buildNavigationData,
  getSafeTitle,
  getNavigationOrder,
} from '@utilities';
import MenuItem from './menu-item';
import { LanguageSelector } from '@components';

/**
 * Menu.
 */
const Menu = (): JSX.Element | null => {
  const { siteData }: DataContextProps = useSiteData();
  if (siteData) {
    const { currentLocale, allEmpowerMePages, currentPageType } = siteData;
    const language = currentLocale ?? 'en';
    const data = allEmpowerMePages;
    const navigationData = buildNavigationData(data, language, currentPageType);
    const navigationOrder = getNavigationOrder(currentPageType);

    if (navigationData) {
      /**
       * Render.
       */
      return (
        <nav className="top-navigation">
          <ul className="top-navigaton-list">
            {navigationData &&
              navigationOrder.map((navigationKey: string) => {
                if (navigationKey !== 'no-navigation') {
                  return (
                    <MenuItem
                      linkTitle={getSafeTitle(navigationKey, siteData)}
                      path={`/${language}/${navigationKey}/`}
                      // @ts-ignore
                      menuData={navigationData[navigationKey]}
                      pageType={currentPageType}
                      key={navigationKey}
                    />
                  );
                }
                return null;
              })}
            <li className="search">
              <button
                onClick={() => {
                  window.open(`/${currentLocale}/search/`, '_self')?.focus();
                }}
                data-button-variation="no-outline"
                data-button-type="control"
              >
                <i className="icon-search" />
              </button>
            </li>
            <LanguageSelector selectorType="top-bar" />
          </ul>
        </nav>
      );
    }
  }
  return null;
};
export default Menu;
